<template>
  <div class="crms-tasks">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "AccordionComponent",
  props: {
    oneOpen: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    /*tabs*/
    var accordion = (function () {

      var $accordion = $('.crms-tasks');
      var $accordion_header = $accordion.find('.js-accordion-header');
      var $accordion_item = $('.js-accordion-item');

      // default settings
      var settings = {
        // animation speed
        speed: 400,

        // close all other accordion items if true
        oneOpen: false
      };

      return {
        // pass configurable object literal
        init: function ($settings) {
          $accordion_header.on('click', function () {
            accordion.toggle($(this));
          });

          $.extend(settings, $settings);

          // ensure only one accordion is active if oneOpen is true
          if (settings.oneOpen && $('.crms-task-item.active').length > 1) {
            $('.crms-task-item.active:not(:first)').removeClass('active');
          }

          // reveal the active accordion bodies
          $('.crms-task-item.active').find('> .js-accordion-body').show();
        },
        toggle: function ($this) {

          if (settings.oneOpen && $this[0] != $this.closest('.crms-tasks').find('> .crms-task-item.active > .js-accordion-header')[0]) {
            $this.closest('.crms-tasks')
              .find('> .crms-task-item')
              .removeClass('active')
              .find('.js-accordion-body')
              .slideUp()
          }

          // show/hide the clicked accordion item
          $this.closest('.crms-task-item').toggleClass('active');
          $this.next().stop().slideToggle(settings.speed);
        }
      }
    })();
    accordion.init({
      speed: 300,
      oneOpen: this.oneOpen
    });
  }
}
</script>

<style scoped>

</style>
